export default __webpack_public_path__ + "static/media/ChristianSneaker_Wide.32b3a7c8.jpg";